import { Action } from '@ngrx/store';
import { BidResultsWithType } from './state';

export enum BidResultsActionTypes {
  LoadBidResults = '[Bid Results] Load',
  LoadBidResultsSuccess = '[Bid Results] Load Success',
  LoadBidResultsFail = '[Bid Results] Load Fail',
  ResetBidResults = '[Bid Results] Reset'
}

export class LoadBidResults implements Action {
  public readonly type = BidResultsActionTypes.LoadBidResults;
  constructor(public readonly payload: string) {}
}

export class LoadBidResultsSuccess implements Action {
  public readonly type = BidResultsActionTypes.LoadBidResultsSuccess;
  constructor(public readonly payload: BidResultsWithType) {}
}
export class LoadBidResultsFail implements Action {
  public readonly type = BidResultsActionTypes.LoadBidResultsFail;
  constructor(public readonly payload: string) {}
}
export class ResetBidResults implements Action {
  public readonly type = BidResultsActionTypes.ResetBidResults;
}

export type BidResultsActionUnion =
  | LoadBidResults
  | LoadBidResultsSuccess
  | LoadBidResultsFail
  | ResetBidResults;
